var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.number))]}),_vm._v(" "),(_vm.highlightNumber)?_c('span',{staticClass:"label label-primary"},[_vm._v("Late/Spare")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }